import * as React from "react"
export const BlueTicket = (props) => (
  <svg
    width={91}
    height={91}
    viewBox='0 0 91 91'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <circle cx={45.5} cy={45.5} r={45.5} fill='#E2E1F1' />
    <path
      d='M64.2499 43.775V45.5C64.2476 49.5433 62.9383 53.4775 60.5174 56.7159C58.0964 59.9543 54.6935 62.3234 50.8162 63.4698C46.9388 64.6162 42.7947 64.4785 39.002 63.0773C35.2093 61.6761 31.9711 59.0864 29.7704 55.6945C27.5698 52.3025 26.5245 48.2901 26.7905 44.2556C27.0566 40.221 28.6196 36.3806 31.2467 33.307C33.8737 30.2334 37.4239 28.0913 41.3677 27.2003C45.3116 26.3092 49.4379 26.7169 53.1311 28.3625'
      stroke='#554DF1'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M64.25 30.5L45.5 49.2688L39.875 43.6438'
      stroke='#554DF1'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
